import { useEffect, useRef, useState } from "react";
import { useProductData } from "@/zustand/productStore.js";
import { useCartData } from "@/zustand/cartStore.js";
import { VariantPicker } from "@/components/ProductPackages/VariantPicker";

// Shared per-item variant pickers for both product picker layouts.
const PackageVariants = ({ product, active, modifier, onClick }) => {
  const productData = useProductData();
  const { defaultSize, defaultColor } = useCartData();
  const [fadeIn, setFadeIn] = useState(false);
  const variantsRef = useRef();

  const productsContent = window.post_template?.checkout_v4_products;
  const colorVariantHeading = productsContent?.tr_checkout_v4_colorVariantHeading;
  const sizeVariantHeading = productsContent?.tr_checkout_v4_sizeVariantHeading;

  const isEachPicker = productData?.variants_picker_type == "each";
  const showColorPicker =
    isEachPicker && productData?.enable_color_variants && productData?.product_color_variants?.length > 0;
  const showSizePicker =
    isEachPicker && productData?.enable_size_variants && productData?.product_size_variants?.length > 0;

  useEffect(() => {
    if (!active) {
      setFadeIn(false);
      return;
    }

    const timeout = setTimeout(() => {
      setFadeIn(true);
    }, 300);

    return () => clearTimeout(timeout);
  }, [active]);

  if (!active || (!showColorPicker && !showSizePicker)) return null;

  return (
    <div
      className={`variants-container ${modifier ? `variants-container--${modifier}` : ""} ${
        fadeIn ? "variants-container--show" : "variants-container--hide"
      }`}
      style={fadeIn ? { maxHeight: `${variantsRef?.current?.clientHeight}px` } : { maxHeight: "0px" }}
      onClick={onClick}
    >
      <div ref={variantsRef}>
        {showColorPicker && (
          <VariantPicker
            defaultValue={defaultColor}
            type="color"
            heading={colorVariantHeading}
            id={product?.amount}
            data={productData?.product_color_variants}
            numberOfItems={product?.amount}
          />
        )}
        {showSizePicker && (
          <VariantPicker
            defaultValue={defaultSize}
            type="size"
            heading={sizeVariantHeading}
            id={product?.amount}
            data={productData?.product_size_variants}
            numberOfItems={product?.amount}
          />
        )}
      </div>
    </div>
  );
};

export default PackageVariants;
